'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
import { faPaperPlane as o } from "../../external/@fortawesome/pro-regular-svg-icons/index.js";
import { FontAwesomeIcon as n } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { useState as i } from "react";
import l from "./chat.module.scss.js";
const f = ({ onSubmit: a }) => {
  const [t, r] = i("");
  return /* @__PURE__ */ e.jsxs(
    "form",
    {
      className: l["message-input-field"],
      onSubmit: (s) => {
        s.preventDefault(), a(t), r("");
      },
      children: [
        /* @__PURE__ */ e.jsx(
          "input",
          {
            id: "message-input",
            autoFocus: !0,
            type: "text",
            value: t,
            onChange: (s) => r(s.currentTarget.value),
            placeholder: "Type your message..."
          }
        ),
        /* @__PURE__ */ e.jsx("label", { hidden: !0, htmlFor: "message-input", children: "Message" }),
        /* @__PURE__ */ e.jsx(
          "button",
          {
            type: "submit",
            "aria-label": "Send",
            disabled: t.length === 0,
            children: /* @__PURE__ */ e.jsx(n, { icon: o })
          }
        )
      ]
    }
  );
};
export {
  f as default
};
